import { http } from '../config';
import {
  REQUEST_OTP_LOGIN_ENDPOINT,
  REQUEST_OTP_REGISTER_ENDPOINT,
  REQUEST_OTP_VIA_SMS,
  RESEND_OTP_ENDPOINT,
  VERIFY_OTP_ENDPOINT,
  VERIFY_SMS_OTP_ENDPOINT,
} from '../endpoints';
import {
  LoginOTPRequest,
  RegisterOTPRequest,
  RequestOTPResponse,
  ResendOTPRequest,
  ResendOTPViaSmsRequest,
  VerifyOTPRequest,
  VerifyOTPResponse,
} from '../types';

export async function putRequestOTPRegister(
  body: RegisterOTPRequest
): Promise<RequestOTPResponse> {
  return http.put(REQUEST_OTP_REGISTER_ENDPOINT, body, {
    skipAuthRefresh: true,
  });
}

export async function putRequestOTPLogin(
  body: LoginOTPRequest
): Promise<RequestOTPResponse> {
  return http.put(REQUEST_OTP_LOGIN_ENDPOINT, body, {
    skipAuthRefresh: true,
    withCredentials: false,
  });
}
export async function putRequestOTPLoginViaSms(
  body: ResendOTPViaSmsRequest
): Promise<RequestOTPResponse> {
  return http.post(REQUEST_OTP_VIA_SMS, body, {
    skipAuthRefresh: true,
    withCredentials: false,
  });
}

export async function putVerifyOTPEmail(
  body: VerifyOTPRequest
): Promise<VerifyOTPResponse> {
  return http.put(VERIFY_OTP_ENDPOINT, body, {
    skipAuthRefresh: true,
    withCredentials: false,
  });
}
export async function putVerifyOTPSms(
  body: VerifyOTPRequest
): Promise<VerifyOTPResponse> {
  return http.post(VERIFY_SMS_OTP_ENDPOINT, body, {
    skipAuthRefresh: true,
    withCredentials: false,
  });
}

export async function putResendOTP(
  body: ResendOTPRequest
): Promise<RequestOTPResponse> {
  return http.put(RESEND_OTP_ENDPOINT, body);
}
